/* eslint-disable react/prop-types */
import React from "react";
import { useLocation, useParams } from "react-router-dom";

import FormField from "components/FormField";
import SoftEditor from "components/SoftEditor";
import SelectField from "components/SelectField";
import FileField from "components/FileUploadField";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Grid } from "@mui/material";
import { ACTION_TYPE_ENUM } from "enums/action-type";

const actionTypeOptions = [
  { value: ACTION_TYPE_ENUM.RESPONSE, label: ACTION_TYPE_ENUM.RESPONSE },
  {
    value: ACTION_TYPE_ENUM.NOT_RESPONSE,
    label: ACTION_TYPE_ENUM.NOT_RESPONSE,
  },
];

export default function Fields({ formData }) {
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const containCreate = location.pathname?.includes("/create");
  const { formField, values, errors, touched, setFieldValue } = formData;
  const {
    name,
    members,
    email,
    introduction,
    taxCode,
    phone,
    accountNumber,
    address,
    logo,
    actionType,
    bankBranch,
    bankOwner,
  } = formField;
  const {
    logo: logoV,
    name: nameV,
    members: membersV,
    email: emailV,
    introduction: introductionV,
    taxCode: taxCodeV,
    phone: phoneV,
    accountNumber: accountNumberV,
    address: addressV,
    actionType: actionTypeV,
    bankBranch: bankBranchV,
    bankOwner: bankOwnerV,
  } = values;
  console.log({
    values,
  });
  return (
    <SoftBox>
      <SoftBox lineHeight={0}>
        <SoftTypography variant="h5" fontWeight="bold">
          {id ? (containEdit ? "Cập nhật" : "Chi tiết") : "Tạo"} công ty
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={1} maxWidth={150}>
        <FileField
          name={logo.name}
          label={logo.label}
          error={errors.logo && touched.logo}
          success={logoV && Object.keys(logoV).length > 0 && !errors.logo}
        />
      </SoftBox>
      <SoftBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={name.type}
              label={name.label}
              name={name.name}
              value={nameV}
              placeholder={name.placeholder}
              error={errors.name && touched.name}
              success={nameV.length > 0 && !errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={members.type}
              label={members.label}
              name={members.name}
              value={membersV}
              placeholder={members.placeholder}
              // error={errors.members && touched.members}
              // success={membersV.toString().length > 0 && !errors.members}
            />
          </Grid>
          {containCreate && (
            <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
              <FormField
                type={email.type}
                label={email.label}
                name={email.name}
                value={emailV || ""}
                placeholder={email.placeholder}
                error={errors.email && touched.email}
                success={emailV?.length > 0 && !errors.email}
                disabled={!containCreate}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={phone.type}
              label={phone.label}
              name={phone.name}
              value={phoneV}
              placeholder={phone.placeholder}
              // error={errors.phone && touched.phone}
              // success={phoneV.length > 0 && !errors.phone}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={taxCode.type}
              label={taxCode.label}
              name={taxCode.name}
              value={taxCodeV}
              placeholder={taxCode.placeholder}
              error={errors.taxCode && touched.taxCode}
              success={taxCodeV.length > 0 && !errors.taxCode}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={accountNumber.type}
              label={accountNumber.label}
              name={accountNumber.name}
              value={accountNumberV}
              placeholder={accountNumber.placeholder}
              error={errors.accountNumber && touched.accountNumber}
              success={accountNumberV.length > 0 && !errors.accountNumber}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={bankOwner.type}
              label={bankOwner.label}
              name={bankOwner.name}
              value={bankOwnerV}
              placeholder={bankOwner.placeholder}
              // error={errors.bankOwner && touched.bankOwner}
              // success={bankOwnerV.length > 0 && !errors.bankOwner}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={bankBranch.type}
              label={bankBranch.label}
              name={bankBranch.name}
              value={bankBranchV}
              placeholder={bankBranch.placeholder}
              // error={errors.bankBranch && touched.bankBranch}
              // success={bankBranchV.length > 0 && !errors.bankBranch}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={address.type}
              label={address.label}
              name={address.name}
              value={addressV}
              placeholder={address.placeholder}
              // error={errors.address && touched.address}
              // success={addressV.length > 0 && !errors.address}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} style={{ paddingTop: "0px" }}>
            <SelectField
              options={actionTypeOptions}
              type={actionType.type}
              label={actionType.label}
              name={actionType.name}
              value={actionTypeV}
              placeholder={actionType.placeholder}
              // error={errors.actionType && touched.actionType}
              // success={actionTypeV.length > 0 && !errors.actionType}
            />
          </Grid>
          <Grid item xs={12} style={{ paddingTop: "0px" }}>
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Mô tả
              </SoftTypography>
            </SoftBox>
            <SoftEditor
              name={introduction.name}
              value={introductionV}
              onChange={(value) => setFieldValue("introduction", value)}
            />
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}
